"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isBoolean2 = _interopRequireDefault(require("lodash/isBoolean"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["href", "isActive", "isAnswered", "isCallback", "isIncoming"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CallbackCallIcon = function CallbackCallIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none",
    stroke: "#919499",
    strokeLinejoin: "round",
    d: "M7.125 2.393L12.333 1 9.208 6.571 14 5.286 5.667 16l2.5-6.429L4 10.643z"
  }));
};
CallbackCallIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 17"
};
var IncomingCallIcon = function IncomingCallIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.872 6.65L2.318 2M7.83 4l-.718 2.962L4 7.214M14.177 1.35l.984.879c.743.661.863 1.597.36 2.807-.755 1.815-3.585 6.192-9.75 9.891-1.36.957-2.581.741-3.142 0-.374-.494-.74-.967-1.1-1.42-.4-.616-.231-1.188.504-1.715 1.102-.792.75-.513 1.65-1.13.902-.618.894-.48 2.089 0 1.194.48 1.206.897 2.39-.233.789-.753 1.8-1.783 3.033-3.088.463-.434.463-.977 0-1.627-.694-.974-.694-1.349 0-2.417a20.5 20.5 0 0 1 1.428-1.948c.514-.465 1.032-.465 1.554 0z",
    fill: "none",
    stroke: "#919499"
  }));
};
IncomingCallIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 17"
};
var OutgoingCallIcon = function OutgoingCallIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.384 1.35l.984.879c.743.661.863 1.597.36 2.807-.755 1.815-3.585 6.192-9.75 9.891-1.36.957-2.58.741-3.142 0-.374-.494-.74-.967-1.1-1.42-.4-.616-.231-1.188.504-1.715 1.102-.792.75-.513 1.65-1.13.902-.618.894-.48 2.089 0 1.194.48 1.206.897 2.39-.233.789-.753 1.8-1.783 3.033-3.088.463-.434.463-.977 0-1.627-.694-.974-.694-1.349 0-2.417.463-.712.939-1.361 1.429-1.948.513-.465 1.031-.465 1.553 0zm-10.9 1.8L7.038 7.8m-5.512-2l.718-2.963 3.113-.252",
    fill: "none",
    stroke: "#919499"
  }));
};
OutgoingCallIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 17"
};
var UnansweredIncomingCallIcon = function UnansweredIncomingCallIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.687 3.498L.525.14M4.83 1l-.718 2.962L1 4.214M15.177 2.35l.984.879c.743.661.863 1.597.36 2.807-.755 1.815-3.585 6.192-9.75 9.891-1.36.957-2.581.741-3.142 0-.374-.494-.74-.967-1.1-1.42-.4-.616-.231-1.188.504-1.715 1.102-.792.75-.513 1.65-1.13.902-.618.894-.48 2.089 0 1.194.48 1.206.897 2.39-.233.789-.753 1.8-1.783 3.033-3.088.463-.434.463-.977 0-1.627-.694-.974-.694-1.349 0-2.417a20.5 20.5 0 0 1 1.428-1.948c.514-.465 1.032-.465 1.554 0zM7.065 4L6.57 9.635m3.066-2.571L4 6.57",
    fill: "#ff3939",
    fillRule: "evenodd",
    stroke: "#ff3939"
  }));
};
UnansweredIncomingCallIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
};
var UnansweredOutgoingCallIcon = function UnansweredOutgoingCallIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.177 2.35l.984.879c.743.661.863 1.597.36 2.807-.755 1.815-3.585 6.192-9.75 9.891-1.36.957-2.581.741-3.142 0-.374-.494-.74-.967-1.1-1.42-.4-.616-.231-1.188.504-1.715 1.102-.792.75-.513 1.65-1.13.902-.618.894-.48 2.089 0 1.194.48 1.206.897 2.39-.233.789-.753 1.8-1.783 3.033-3.088.463-.434.463-.977 0-1.627-.694-.974-.694-1.349 0-2.417a20.5 20.5 0 0 1 1.428-1.948c.514-.465 1.032-.465 1.554 0zM3.064 0l-.493 5.635m3.064-2.571L0 2.571m6.12 3.378L9.5 9.283m-4.338-.684l.718-2.962 3.112-.252",
    fill: "#ff3939",
    fillRule: "evenodd",
    stroke: "#ff3939"
  }));
};
UnansweredOutgoingCallIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
};
var TITLES = {
  CALL: 'Открыть звонок в админке',
  CALLBACK: 'Открыть коллбэк в админке'
};
var CallIcon = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var href = _ref.href,
    isActive = _ref.isActive,
    isAnswered = _ref.isAnswered,
    isCallback = _ref.isCallback,
    isIncoming = _ref.isIncoming,
    restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (!((0, _isBoolean2["default"])(isAnswered) && (0, _isBoolean2["default"])(isIncoming)) && !isCallback) {
    return null;
  }
  var Icon;
  if (isCallback) {
    Icon = CallbackCallIcon;
  } else if (isIncoming) {
    Icon = isActive || isAnswered ? IncomingCallIcon : UnansweredIncomingCallIcon;
  } else {
    Icon = isActive || isAnswered ? OutgoingCallIcon : UnansweredOutgoingCallIcon;
  }
  var title;
  if (href) {
    title = isCallback ? TITLES.CALLBACK : TITLES.CALL;
  }
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isHovered = _useState2[0],
    setHovered = _useState2[1];
  var enableHovered = function enableHovered() {
    return setHovered(true);
  };
  var disableHovered = function disableHovered() {
    return setHovered(false);
  };
  return /*#__PURE__*/_react["default"].createElement(StyledCallIcon, (0, _extends2["default"])({
    href: href,
    isHovered: isHovered,
    onClick: disableHovered,
    onMouseEnter: enableHovered,
    onMouseLeave: disableHovered,
    target: "_blank",
    title: title
  }, restProps), /*#__PURE__*/_react["default"].createElement(Icon, null));
});
CallIcon.propTypes = {
  className: _propTypes["default"].string,
  href: _propTypes["default"].string,
  isActive: _propTypes["default"].bool,
  isAnswered: _propTypes["default"].bool,
  isCallback: _propTypes["default"].bool,
  isIncoming: _propTypes["default"].bool
};
CallIcon.defaultProps = {
  className: '',
  href: null,
  isActive: false,
  isAnswered: null,
  isCallback: false,
  isIncoming: null
};
var StyledCallIcon = _styledComponents["default"].a.withConfig({
  displayName: "CallIcon__StyledCallIcon",
  componentId: "sc-c4rag-0"
})(["display:block;height:20px;width:20px;svg{height:100%;width:100%;}:hover{", "}"], function (_ref2) {
  var href = _ref2.href,
    isHovered = _ref2.isHovered;
  return href && isHovered && "\n      svg > * {\n        fill: none;\n        stroke: #007aff;\n      }\n    ";
});
var _default = exports["default"] = CallIcon;